import { ReactNode } from "react";
import { History } from "lucide-react";
import { Alert, AlertDescription } from "~/components/ui/alert";
import { Button } from "~/components/ui/button";

interface OlderVersionNoticeProps {
  children: ReactNode;
  onViewLatest: () => void;
}

// Shared "you're viewing an older configuration version" banner used by both the
// Cohort Explorer landing view and the per-domain detail view. Wraps the design
// system `Alert` (warning) so callers only supply the message copy.
export const OlderVersionNotice = ({ children, onViewLatest }: OlderVersionNoticeProps) => (
  <Alert variant="warning">
    <History aria-hidden="true" />
    <AlertDescription>
      <div className="flex w-full items-center gap-3">
        <span className="flex-1">{children}</span>
        <Button variant="outline" size="sm" className="shrink-0" onClick={onViewLatest}>
          View latest
        </Button>
      </div>
    </AlertDescription>
  </Alert>
);
